var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuggestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6898 0.209812L0.329845 9.48981C-0.310155 10.0698 0.0498451 11.1398 0.909845 11.2198L8.99985 11.9998L4.14984 18.7598C3.92984 19.0698 3.95984 19.4998 4.22984 19.7698C4.52984 20.0698 4.99985 20.0798 5.30985 19.7898L15.6698 10.5098C16.3098 9.92981 15.9498 8.85981 15.0898 8.77981L6.99985 7.99981L11.8498 1.23981C12.0698 0.929812 12.0398 0.499812 11.7698 0.229812C11.6285 0.0854273 11.436 0.00240889 11.2339 -0.00133269C11.0319 -0.00507427 10.8365 0.070761 10.6898 0.209812Z",
    fill: "#49BA76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestion);
export default __webpack_public_path__ + "static/media/suggestion.aa60138d5fc7c3ed45913a4e89ae8da7.svg";
export { ForwardRef as ReactComponent };